import { omit } from '@bugbug/core/utils/toolbox';
import { normalize } from 'normalizr';

import type { NormalizedTestState } from './tests.types';

import type { Step } from '@bugbug/core/types/steps';
import type { Test } from '@bugbug/core/types/tests';
import {
  ENTITIES,
  showInternalServerError,
  showPendingRequestToast,
} from '~/services/toasts/internalServerError';

import { elementScreenshotSchema, testSchema } from './tests.schema';

export const getElementsScreenshotsFromSteps = (
  steps: Record<Step['id'], Step> = {},
): Record<Step['id'], string> => {
  const elementsData = normalize(Object.values(steps), [elementScreenshotSchema]);
  return elementsData.entities.elementsScreenshots || {};
};

export const normalizeTest = (test: Test): NormalizedTestState => {
  const normalizedResponse = normalize(test, testSchema);

  const normalizedTest = normalizedResponse.entities.tests![test.id]!;
  if (normalizedTest.testRun) {
    normalizedTest.testRun = {
      ...normalizedTest.testRun,
      test: omit(['testRun'], test),
    };
  }

  return {
    test: normalizedTest,
    groups: normalizedResponse.entities.groups || {},
    steps: normalizedResponse.entities.steps || {},
    elementsScreenshots: getElementsScreenshotsFromSteps(normalizedResponse.entities.steps) || {},
  };
};

export const showTestError = showInternalServerError(ENTITIES.TEST);
export const showTestsError = showInternalServerError(ENTITIES.TESTS);
export const showStepError = showInternalServerError(ENTITIES.STEP);
export const showStepsError = showInternalServerError(ENTITIES.STEPS);
export const showStepFileError = showInternalServerError(ENTITIES.FILE);
export const showGroupError = showInternalServerError(ENTITIES.GROUP);
export const showPendingTest = showPendingRequestToast(ENTITIES.TEST);
export const showPendingGroup = showPendingRequestToast(ENTITIES.GROUP);
